/**
 * Root is the workspace when a cookie, stored session, or incoming handoff
 * suggests an account. The lazy auth island verifies that hint. Public
 * visitors receive the landing page without downloading Clerk or owner code.
 * /overview always exposes the public site, including to signed-in owners.
 */

import { lazy, Suspense } from "react";
import { useLocation } from "react-router-dom";
import LandingPage from "@/pages/LandingPage";
import { useSessionHint } from "@/lib/auth/session-hint";

const WorkspacePage = lazy(() => import("@/pages/WorkspacePage"));

export default function RootPage() {
  const signedIn = useSessionHint();
  const { hash } = useLocation();

  // Existing public capture links must remain usable by an owner too.
  if (!signedIn || hash === "#try-it") return <LandingPage />;

  return (
    <Suspense fallback={<div role="status" className="grid min-h-dvh place-items-center bg-canvas text-ink-muted">Opening your workspace…</div>}>
      <WorkspacePage />
    </Suspense>
  );
}
